
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import UserService from "./services/user.service";
import MessageBox from './MessageBox';

import { Container, Form, FormLabel, Row, Col } from "react-bootstrap"
import Alert from 'react-bootstrap/Alert'
import { login } from "./actions/auth.js";
import { logout } from "./actions/auth.js";
import { register } from "./actions/auth.js";
import { WrapperApp } from "./App.js"

const RegistroNuevoUsuario = () => {

  const { control, handleSubmit, formState: { errors },} = useForm({
    defaultValues: {
      primernombre: "",
      primerapellido: "",
      segundonombre: "",
      segundoapellido: "",
      curp: "",
      fechadenacimiento: "",
      telefonomovil: "",
      email: "",
      contraseña: "",
      confirmarcontraseña: "",
      bio: ""
    },
  });  

  const [primernombre, setPrimernombre] = useState("");
  const [segundonombre, setsegundonombre] = useState("");
  const [primerapellido, setprimerapellido] = useState("");
  const [segundoapellido, setsegundoapellido] = useState("");
  const [fechadenacimiento, setfechadenacimiento] = useState(null);
  const [curp, setcurp] = useState("");
  const [telefonomovil, settelefonomovil] = useState("");
  const [arean1, setarean1] = useState(null);
  const [arean2, setarean2] = useState(null);
  const [imageprofile, setimageprofile] = useState("");
  const [bio, setbio] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [confirmpassword, setconfirmpassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [genero, setgenero] = useState("");
  const [banco, setbanco] = useState("");
  const [clabe, setclabe] = useState("");
  
  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');
  

  const { isLoggedIn } = useSelector(state => state.auth);
  //const { user } = useSelector(state => state.auth);
  const [user, setUser] = useState({});  

  const { message } = useSelector(state => state.message);

  const dispatch = useDispatch();

  const onChangeprimernombre = (e) => {  
    //console.log(e.target.value);
    const primernombre = e.target.value;
    setPrimernombre(primernombre);
  };

  const onChangesegundonombre = (e) => {  
    //console.log(e.target.value);
    const segundonombre = e.target.value;
    setsegundonombre(segundonombre);
  };
  
  const onChangeprimerapellido = (e) => {  
    //console.log(e.target.value);
    const primerapellido = e.target.value;
    setprimerapellido(primerapellido);
  };
  
  const onChangesegundoapellido = (e) => {  
    //console.log(e.target.value);
    const segundoapellido = e.target.value;
    setsegundoapellido(segundoapellido);
  };
  
  const onChangefechadenacimiento = (e) => {  
    //console.log(e.target.value);
    const fechadenacimiento = e.target.value;
    setfechadenacimiento(fechadenacimiento);
  };
  
  const onChangecurp = (e) => {  
    //console.log(e.target.value);
    const curp = e.target.value;
    setcurp(curp);
  };
  
  const onChangetelefonomovil = (e) => {  
    //console.log(e.target.value);
    const telefonomovil = e.target.value;
    settelefonomovil(telefonomovil);
  };
  
  const onChangearean1 = (e) => {  
    //console.log(e.target.value);
    const arean1 = e.target.value;
    setarean1(arean1);
  };
  
  const onChangearean2 = (e) => {  
    //console.log(e.target.value);
    const arean2 = e.target.value;
    setarean2(arean2);
  };
  
  const onChangeimageprofile = (e) => {  
    //console.log(e.target.value);
    const imageprofile = e.target.value;
    setimageprofile(imageprofile);
  };  

  const onChangebio = (e) => {  
    //console.log(e.target.value);
    const bio = e.target.value;
    setbio(bio);
  };

  const onChangegenero   = (e) => {  
    //console.log(e.target.value);
    const genero = e.target.value;
    setgenero(genero);
  };  

  const onChangeBanco = (e) => {  
    //console.log(e.target.value);
    const banco = e.target.value;
    setbanco(banco);
  };

  const onChangeClabe = (e) => {  
    //console.log(e.target.value);
    const clabe = e.target.value;
    setclabe(clabe);
  }
  
  const onChangeemail = (e) => {  
    //console.log(e.target.value);
    const email = e.target.value;
    setemail(email);
  };

  const onChangePassword = (e) => {
    //console.log(e.target.value);
    const pass = e.target.value;
    setpassword(pass);
  };

  const onChangeConfirmPassword = (e) => {
    //console.log(e.target.value);
    const confirmpass = e.target.value;
    setconfirmpassword(confirmpass);
  };
  

  const handleRegister = (e) => {
    //e.preventDefault();

    setLoading(true);
    
    if (!loading) {
      dispatch(register(e.primernombre, e.segundonombre, e.primerapellido, e.segundoapellido, e.fechadenacimiento, 
        e.curp, e.telefonomovil, e.arean1, e.arean2, e.imageprofile, e.bio, e.genero, e.email, e.contraseña, e.confirmarcontraseña, [1], e.banco, e.clabe))
        .then(() => {
          //props.history.push("/");
          //window.location.reload();
          
          //console.log("registered");
          //setShowsuccess(true);
          //setSuccmessage("Se registró el usuario correctamente. Por favor ingresa a tu cuenta con el usuario y contraseña que diste de alta.");
          //window.location.assign("/login");
          dispatch(login(e.email, e.contraseña))
            .then(() => {
              //props.history.push("/");
              //window.location.assign("/dashboard");
            })
            .catch(() => {
              setLoading(false);
            });
        })
        .catch(() => {
          setLoading(false);
          /*
          setShowsuccess(false);
          setSuccmessage("");
          setShowerror(true);
          setErrmessage(message);
          */
        });
    } 
    else {
      setLoading(false);
    }
  };

  if (isLoggedIn) { 
    //window.location.reload();
    //return <Navigate to="/" />;
    
    return <WrapperApp user={user}/>;    
  };

  return (
    <div className="col-md-12">
      <div className='m-2' style={{textAlign:'center'}}>
        <img src="./logo512.png" width={"120px"}/>
        <div>Hola!</div>
        <div>Agradecemos tu interés por participar en nuestra liga.</div>
        <div>Por favor, proporciona los siguientes datos para continuar</div>
      </div>      

      <Container>
        <hr />
        <Form noValidate onSubmit={handleSubmit(handleRegister)}>
          <Row className='mt-2'>
            <Col className='col-md-3' sm={8}>
                <Controller
                  name="primernombre"
                  control={control}
                  onChange={onChangeprimernombre}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Form.Control
                      {...field}
                        className="m-2"
                        type="text"
                        placeholder="Primer nombre"
                        isInvalid={errors.primernombre}
                        //onChange={onChangeprimernombre}
                        //value={username}
                        
                    />
                  )}
                />
                {errors.primernombre && (
                  <Form.Control.Feedback type="invalid">
                    Se requiere tu nombre
                  </Form.Control.Feedback>
                )}
            </Col>
            <Col className='col-md-3' sm={8}>
              <Controller
                name="segundonombre"
                control={control}
                onChange={onChangesegundonombre}
                rules={{ required: false }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="text"
                      placeholder="Segundo nombre"
                      isInvalid={errors.segundonombre}
                      //onChange={onChangesegundonombre}
                      //value={username}
                      
                  />
                )}
              />
     
            </Col>

            <Col className='col-md-3' sm={8}>
              <Controller
                name="primerapellido"
                control={control}
                onChange={onChangeprimerapellido}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="text"
                      placeholder="Primer apellido"
                      isInvalid={errors.primerapellido}
                      //onChange={onChangeprimerapellido}
                      //value={username}
                      
                  />
                )}
              />
              {errors.primerapellido && (
                <Form.Control.Feedback type="invalid">
                  Se requiere tu primer apellido
                </Form.Control.Feedback>
              )} 
            </Col>

            <Col className='col-md-3' sm={8}>
              <Controller
                name="segundoapellido"
                control={control}
                onChange={onChangesegundoapellido}
                rules={{ required: false }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="text"
                      placeholder="Segundo apellido"
                      isInvalid={errors.username}
                      //onChange={onChangesegundoapellido}
                      //value={username}
                      
                  />
                )}
              />
         
            </Col>

          </Row>

          <Row className='mt-2'>
            <Col className='col-md-3' sm={8}>
              <FormLabel className="m-2">Fecha de Nacimiento</FormLabel>
              <Controller
                name="fechadenacimiento"
                control={control}
                onChange={onChangefechadenacimiento}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="date"
                      placeholder="fecha de nacimiento"
                      isInvalid={errors.fechadenacimiento}
                      //onChange={onChangefechadenacimiento}
                      //value={username}
                      
                  />
                )}
              />
              {errors.fechadenacimiento && (
                <Form.Control.Feedback type="invalid">
                  Se requiere tu fecha de nacimiento.
                </Form.Control.Feedback>
              )}             
            </Col>

            <Col className='col-md-3' sm={8}>
              <FormLabel className="m-2">Teléfono móvil</FormLabel>
              <Controller
                name="telefonomovil"
                control={control}
                onChange={onChangetelefonomovil}
                rules={{ required: true, pattern: /^\d{10}$/ }}                    
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="text"
                      isInvalid={errors.telefonomovil}
                      //onChange={onChangetelefonomovil}
                      //value={username}
                      
                  />
                )}
              />
              {errors.telefonomovil && (
                <Form.Control.Feedback type="invalid">
                  El teléfono móvil debe tener diez dígitos.
                </Form.Control.Feedback>
              )}  
            </Col>

            <Col className='col-md-3' sm={8}>
              <FormLabel className="m-2">Email</FormLabel>
              <Controller
                name="email"
                control={control}
                onChange={onChangeemail}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="text"
                      isInvalid={errors.email}
                      //onChange={onChangeemail}
                      //value={username}
                      
                  />
                )}
              />  
              {errors.email && (
                <Form.Control.Feedback type="invalid">
                  Se requiere tu email.
                </Form.Control.Feedback>
              )} 
            </Col>  
              
            <Col className='col-md-3' sm={8}>
              <FormLabel className="m-2">Género</FormLabel>
              <Controller
                  name="genero"
                  control={control}
                  onChange={onChangegenero}                    
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Form.Select aria-label="Default select example"
                      {...field}
                      isInvalid={errors.genero}>                        
                      <option>Seleccionar</option>
                      <option value="M">Masculino</option>
                      <option value="F">Femenino</option>
                    </Form.Select> 
                  )}
              />
              {errors.genero && (
                <Form.Control.Feedback type="invalid">
                  Se requiere el género
                </Form.Control.Feedback>
              )}
            </Col>                        

            <Col className='col-md-3' sm={8}>
              <FormLabel className="m-2">Banco</FormLabel>
              <Controller
                name="banco"
                control={control}
                onChange={onChangeBanco}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="text"
                      //isInvalid={errors.banco}
                      //onChange={onChangebanco}
                      //value={username}
                      
                  />
                )}
              />  
              {errors.banco && (
                <Form.Control.Feedback type="invalid">
                  Se requiere tu banco.
                </Form.Control.Feedback>
              )} 
            </Col>             

            <Col className='col-md-3' sm={8}>
              <FormLabel className="m-2">CLABE</FormLabel>
              <Controller
                name="clabe"
                control={control}
                onChange={onChangeClabe}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="text"
                      //isInvalid={errors.clabe}
                      //onChange={onChangeclabe}
                      //value={username}
                      
                  />
                )}
              />  
              {errors.clabe && (
                <Form.Control.Feedback type="invalid">
                  Se requiere tu CLABE.
                </Form.Control.Feedback>
              )} 
            </Col>   

            <Col className='col-md-3' sm={8}>
              <FormLabel className="m-2">CURP</FormLabel>
              <Controller
                name="curo"
                control={control}
                onChange={onChangecurp}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="text"
                      isInvalid={errors.curp}
                      //onChange={onChangeclabe}
                      //value={username}
                      
                  />
                )}
              />  
              {errors.curp && (
                <Form.Control.Feedback type="invalid">
                  Se requiere tu CURP.
                </Form.Control.Feedback>
              )} 
            </Col>   

          </Row>                     

          <Row>
            <Col className='col-md-3' sm={8}>
              <FormLabel className="m-2">Contraseña</FormLabel>
              <Controller
                name="contraseña"
                control={control}
                onChange={onChangePassword}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="password"
                      isInvalid={errors.contraseña}
                      //onChange={onChangePassword}
                      //value={username}
                      
                  />
                )}
              />  
              {errors.contraseña && (
                <Form.Control.Feedback type="invalid">
                  Tienes que dar de alta una contraseña.
                </Form.Control.Feedback>
              )} 
            </Col>  


            <Col className='col-md-3' sm={8}>
              <FormLabel className="m-2">Confirmar contraseña</FormLabel>
              <Controller
                name="confirmarcontraseña"
                control={control}
                onChange={onChangeConfirmPassword}
                rules={{ required: true }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="password"
                      isInvalid={errors.confirmarcontraseña}
                      //onChange={onChangeConfirmPassword}
                      //value={username}
                      
                  />
                )}
              />  
              {errors.confirmarcontraseña && (
                <Form.Control.Feedback type="invalid">
                  Tienes que confirmar tu contraseña.
                </Form.Control.Feedback>
              )} 
            </Col>                
          </Row>

          <Row>
            <Col>
              <FormLabel className="m-2">Cuéntanos algo sobre ti!</FormLabel>
              <Controller
                name="bio"
                control={control}
                onChange={onChangebio}
                rules={{ required: false }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                      className="m-2"
                      type="text" 
                      isInvalid={errors.username}
                      //onChange={onChangebio}
                      //value={username}
                      
                  />
                )}
              />  
            </Col>
          </Row>
       
          <div className="form-group m-2">
            <button className="btn btn-secondary btn-block" disabled={loading}>
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              <span>Crear cuenta</span>
            </button>
          </div> 

        <Row className='mt-2'>

          {showerror && (
            <MessageBox show={true} showerror={showerror} errmessage={errmessage}
              onHide={() => {
                setShowerror(false)
              }}
            />
          )}
          {showsuccess && (

            <MessageBox show={true} showsuccess={showsuccess} succmessage={succmessage}
              onHide={() => {
              setShowsuccess(false);
              window.location.reload();
            }}
            />
          )}

        </Row>  
          
          {message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
          )}
          
          <hr />
          <span style={{fontSize:'14px'}}>
            ¿Ya tienes una cuenta? Ingresa <a href="/login">aquí</a>.
          </span>                  
        </Form>
      </Container>

    </div>
  );
};

export default RegistroNuevoUsuario;
